define('TescoMobile_Iovation/js/action/set-device-fingerprint',['mage/storage', '../model/device-fingerprint-config'], function (storage, config) {
  'use strict';

  return (callbackUrl, deviceFingerPrint) => {
    return storage.post(callbackUrl, JSON.stringify({
      fingerprint: {
        device_fingerprint: deviceFingerPrint
      }
    })).done(function (response) {
      config.isFingerprintSaved = true;
      return response;
    });
  };
});

